import BaseModel from "@/Store/BaseModel";

import SampleTestType from "./SampleTestType";

export default class SampleCertType extends BaseModel {
    static entity = 'sampleCertTypeTestRequirements';
    static primaryKey = "uuid";

    static fields() {
        return {
            uuid: this.attr(null),
            sample_cert_type_uuid: this.attr(null),
            sample_test_type_uuid: this.attr(null),
            qty: this.attr(null),
            required: this.attr(null),
            created_by: this.attr(null),
            updated_by: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            test_name: this.attr(null),
            test_type: this.hasOne(SampleTestType, 'uuid', 'sample_test_type_uuid')
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at']
    }

    static name(){
        return "sampleCertTypeTestRequirement"
    }
    static route(){
        return  process.env.VUE_APP_RECORDED_API + "/sampleCertTypeTestRequirements"
    }
    
    static apiConfig = {
        ...super.apiConfig,
        headers: {
            "Accept": "application/json",
            "Authorization": process.env.VUE_APP_RECORDED_API_KEY,
            "VueRoute": window.location.href,
        }
    }
}
